export default "__VITE_ASSET__DgQ65u5l__"